import {
  CustomMappingType,
  ICustomMapping,
} from '@principle-theorem/practice-migrations/interfaces';
import { CustomMapping } from '../../../custom-mapping';
import {
  BaseTransactionTypeMappingHandler,
  IBaseMigrationPaymentTypeSource,
} from '../../../mappings/base-transaction-type';
import {
  CorePracticePaymentType,
  ICorePracticePaymentType,
  PaymentTypeSourceEntity,
} from '../../source/entities/payment-types';

export const PAYMENT_TYPE_CUSTOM_MAPPING_TYPE = 'paymentTypeMapping';

export const PAYMENT_TYPE_MAPPING: ICustomMapping = CustomMapping.init({
  metadata: {
    label: 'Payment Type Mapping',
    description: `Used to map Core Practice Payment Types to Principle Transaction Types. Any unmapped payment types will be assigned to a Manual Transaction type.`,
    type: PAYMENT_TYPE_CUSTOM_MAPPING_TYPE,
  },
  type: CustomMappingType.SelectionList,
});

export class CorePracticePaymentTypeMappingHandler extends BaseTransactionTypeMappingHandler<
  CorePracticePaymentType,
  PaymentTypeSourceEntity
> {
  override customMapping = PAYMENT_TYPE_MAPPING;
  override sourceEntity = new PaymentTypeSourceEntity();

  translateFn = (
    record: ICorePracticePaymentType
  ): IBaseMigrationPaymentTypeSource => {
    return {
      ...record,
      id: record.id.toString(),
    };
  };
}
